import { viewerMode, viewerWidth, isArabic } from '../global';
import Header from "../components/Header";
import Footer from "../components/Footer";

import "../styles/global.css";

const Master = ({withBG, root, children}) => {

  return (
    <div style={{width:viewerWidth, margin:'auto'}}>
    <div className={withBG?'home':''} style={{direction: isArabic?'rtl':'ltr'}}>
      <br/><br/>
      <Header darkText={!withBG} root={root}/>        <br/><br/>
      {children}
      <Footer />
      <div className="FloatingBar White SubHeaderSmall" >(width:{viewerWidth}px) .. (viewerMode:{viewerMode}) .. (lang:{isArabic?'Ar':'En'}) .. (withBG:{withBG?'Yes':'No'})</div>
    </div>
    </div>
  );
};


export default Master;
